// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*@value screen-sm: (max-width: 970px);*/
`, "",{"version":3,"sources":["webpack://./src/breakpoints.css"],"names":[],"mappings":"AAAA,wCAAwC","sourcesContent":["/*@value screen-sm: (max-width: 970px);*/\n\n@value screen-sm: (min-width: 971px) and (max-width: 1366px);\n@value screen-sm-max: (max-width: 1366px);\n\n@value screen-md: (min-width: 971px) and (max-width: 1919px);\n@value screen-md-min: (min-width: 1367px);\n@value screen-md-max: (max-width: 1919px);\n\n@value screen-lg: (min-width: 1920px) and (max-width: 4479px);\n@value screen-lg-min: (min-width: 1920px);\n\n@value screen-xl: (min-width: 4480px);\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"screen-sm": `(min-width: 971px) and (max-width: 1366px)`,
	"screen-sm-max": `(max-width: 1366px)`,
	"screen-md": `(min-width: 971px) and (max-width: 1919px)`,
	"screen-md-min": `(min-width: 1367px)`,
	"screen-md-max": `(max-width: 1919px)`,
	"screen-lg": `(min-width: 1920px) and (max-width: 4479px)`,
	"screen-lg-min": `(min-width: 1920px)`,
	"screen-xl": `(min-width: 4480px)`
};
export default ___CSS_LOADER_EXPORT___;
